module.exports = __webpack_public_path__ + "img/book-blank.08669357.svg";